import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ngSelectTitle'
})
export class NgSelectTitlePipe implements PipeTransform {

  transform(items: any[], key: string = 'name'): string {
    if (!items || !Array.isArray(items)) { return ''; }
    return items.map(item => item?.[key]).filter(Boolean).join(', ');
  }

}
